<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="4">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaFornecedores"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">FORNECEDORES</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoFornecedor = true" tile color="#00253E" :disabled="user.tipo == 'ADMIN' ? (empresaSelecionada == '') : false">
                <v-icon left dark>add_circle</v-icon>Adicionar Fornecedor
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn color="teal" icon @click="editItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn color="red" icon @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <!-- CARD INSERE Produtos -->
      <v-dialog v-model="dialogoFornecedor" persistent max-width="600px">
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="fornecedor.nome" outlined label="Nome" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="fornecedor.descricao" outlined label="Descrição" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="fornecedor.email" outlined label="E-mail" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field 
                  v-model="fornecedor.telefone" 
                  outlined 
                  label="Telefone"
                  v-mask="telefoneMask" 
                  color="#94AAB4" 
                  hide-details 
                  dense>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="salvarFornecedor">Salvar</v-btn>
            <v-btn text color="red" @click="dialogoFornecedor = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { mask } from 'vue-the-mask'
  export default {
    components: {Snackbar},
    directives: { mask },
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      addUser: false,
      dialogoFornecedor: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', value: 'nome' },
          { text: 'Descrição', value: 'descricao' },
          { text: 'Email', value: 'email' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Ações', value: 'action',  sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      empresas: [],
      perfis: [],
      editedIndex: -1,
      fornecedor: {
        nome: "",
        descricao: "",
        email: "",
        telefone: "",
        empresaId: "",
      },
      fornecedorDefault: {
        nome: "",
        descricao: "",
        email: "",
        telefone: "",
        empresaId: "",
      },
      events: [],
    }),

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj
      }),
      formTitleProd() {
        return this.editedIndex === -1 ? 'Adicionar novo fornecedor' : 'Editar fornecedor';
      },
      telefoneMask() {
        return this.fornecedor.telefone.length === 15 ? "(##) #####-####" : "(##) ####-####";
        
      }
    },

    watch: {
      dialogoFornecedor(val) {
        if (val == false) {
          setTimeout(() => {
            this.fornecedor = Object.assign({}, this.fornecedorDefault)
            this.editedIndex = -1
          }, 300)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN' || this.user.tipo == 'ADMIN_PRODUTORA') {
        this.carregaEmpresas()
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaFornecedores(empresaId) {
        await axios.get(baseApiUrl + 'Fornecedores?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
          }
        })
      },

      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.fornecedor = Object.assign({}, item)
        this.dialogoFornecedor = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir o fornecedor: ' + item.nome + '?')
        let vm = this
        if (r == true) {
            await axios.delete(`${baseApiUrl}Fornecedores/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
            .then(response => {
              if (response.data) {
                this.carregaFornecedores(this.empresaSelecionada)
              }
            })
            .catch(() => {
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
        }
      },

      formatDate(date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async salvarFornecedor() {
        var vm = this
        if (this.fornecedor.nome && this.fornecedor.descricao /* && this.fornecedor.email */ && this.fornecedor.telefone) {
          this.fornecedor.empresaId = this.user.tipo == 'ADMIN'? this.empresaSelecionada : this.companyobj.id
          await axios.post(baseApiUrl + 'Fornecedores/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.fornecedor)
          .then(response => {
            if (response.data) {
              this.dialogoFornecedor = false              
              this.carregaFornecedores(this.empresaSelecionada)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
